import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "flex flex-row items-center space-x-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: 
      `text-${_ctx.textSize}px ${_ctx.padding} text-${
          _ctx.textColor.includes('text-')
            ? _ctx.textColor.replace('text-', '')
            : _ctx.textColor
        } bg-${
          _ctx.color.includes('bg-')
            ? _ctx.color.replace('bg-', '')
            : _ctx.disabled
            ? 'gray-lp-600'
            : _ctx.color
        } ${_ctx.rounded ? 'rounded-full' : 'rounded'} ${
          _ctx.shadow ? 'border border-black' : ''
        } font-${_ctx.weight} ${_ctx.border ? `border border-${_ctx.borderColor}` : ''}`
      ,
      style: `${_ctx.shadow ? 'box-shadow: 2px 2px 0px #000000;' : ''}`
    }, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createVNode("div", _hoisted_2, [
          (_ctx.iconLeft)
            ? (_openBlock(), _createBlock("img", {
                key: 0,
                src: require(`@/app/ui/assets/svg/${_ctx.iconLeft}.svg`),
                class: "w-5",
                alt: "iconLeft"
              }, null, 8, ["src"]))
            : _createCommentVNode("", true),
          _createVNode("div", {
            class: _ctx.textTransform,
            style: 
              `${
                _ctx.shadow
                  ? _ctx.disabled
                    ? 'text-shadow: 1px 1px 0px #000000, 2px 2px 0px #78787A;'
                    : 'text-shadow: 1px 1px 0px #000000, 2px 2px 0px #AD0020;'
                  : ''
              }`
            
          }, _toDisplayString(_ctx.label), 7),
          (_ctx.icon)
            ? (_openBlock(), _createBlock("img", {
                key: 1,
                src: require(`@/app/ui/assets/svg/${_ctx.icon}.svg`),
                class: "w-5",
                alt: "icon"
              }, null, 8, ["src"]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 6)
  ]))
}